import { inject, Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable } from 'rxjs';
import { PriceCategoryService } from '@doc/api/server-bo';

@Injectable({
  providedIn: 'root'
})
export class PriceCategoryResolver implements Resolve<boolean> {
  private eventService = inject(PriceCategoryService);
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.eventService.getPriceCategories({}).pipe(
      catchError(error => {
        return [];
      })
    )
  }
}
